module.exports = __webpack_public_path__ + "img/money-anticipation.012692d0.svg";